export function getPeriodOptions(t) {
  return [
    { value: 'all', label: t('periods.allHistory') },
    { value: 'Today', label: t('periods.today') },
    { value: 'Yesterday', label: t('periods.yesterday') },
    { value: 'CurrentWeek', label: t('periods.currentWeek') },
    { value: 'CurrentMonth', label: t('periods.currentMonth') },
    { value: 'PreviousMonth', label: t('periods.previousMonth') },
    { value: 'LastThreeMonth', label: t('periods.lastThreeMonth') },
    { value: 'Last6Month', label: t('periods.last6Month') },
    { value: 'custom', label: t('periods.custom') },
  ];
}

/** Bot history: Current (active bot session today) first, then shared period options. */
export function getBotPeriodOptions(t) {
  return [
    { value: 'Current', label: t('periods.current') },
    ...getPeriodOptions(t),
  ];
}

export function findPeriodOption(options, value) {
  return options.find((option) => option.value === value) ?? options[0];
}

export function getEaPeriodOptions(t) {
  return getPeriodOptions(t).map((option) =>
    option.value === 'custom' ? { ...option, value: 'Custom' } : option,
  );
}
